import { getStartEndDateFromRange } from '../../utilities/DateUtils';
import { formatNumber } from '../../utilities/Helpers';
import api, { realTimeApiInstance } from '../api';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';
import dayjs from 'dayjs';

export const getDetailedDailyDowntime = async (assetId: string) => {
  const requestPayload = createWrapperPayload('GET', `/pumpchecker/api/v1/Downtime/GetWellDowntimes/${assetId}`);
  const resp = await api.post(wrapperConstants.router, requestPayload);
  const data = (resp?.data || []).map((item: any) => ({ ...item, uniqueId: crypto.randomUUID() }));
  return data;
};
export const getDetailedDailyDowntimeTier1 = async ({ assetId }: { assetId: string }) => {
  try {
    const { startDate, endDate } = getStartEndDateFromRange('1Y');

    const startDateStr = dayjs(startDate).format('YYYY-MM-DD HH:mm:ss.SSS');
    const endDateStr = dayjs(endDate).format('YYYY-MM-DD HH:mm:ss.SSS');

    const response: any = await realTimeApiInstance.get(
      `/RealTimeData/GetAssetDowntimeAndShutdownData?AssetId=${assetId}&startDate=${startDateStr}&endDate=${endDateStr}&POPDate=&fetchAllDowntimes=true`,
    );
    const data = (response?.data?.last5Shutdowns ?? []).map((item: any) => ({
      ...item,
      IndividualDateLocalString: item.dateLocalString,
      IndividualEndDateLocalString: item.endDateLocalString,
      Hours: formatNumber(item.hours, 3),
    }));
    return data;
  } catch (error) {
    console.error('Error fetching detailed downtime data', error);
    return undefined;
  }
};

export const deleteDetailedDailyDowntime = async (downtimeId: number) => {
  const requestPayload = createWrapperPayload(
    'DELETE',
    `/pumpchecker/api/v1/Downtime/DeleteWellDowntime/${downtimeId}`,
  );
  const resp = await api.post(wrapperConstants.router, requestPayload);
  return resp?.data;
};

export const getDowntimeCategories = async () => {
  const requestPayload = createWrapperPayload('GET', `/pumpchecker/api/v1/Lookup/GetDowntimeGroupings`);
  const resp = await api.post(wrapperConstants.router, requestPayload);
  return resp?.data ?? [];
};

export const getDowntimeSubCategories = async (category: string) => {
  const requestPayload = createWrapperPayload(
    'GET',
    `/pumpchecker/api/v1/Lookup/GetDowntimeCodesByGrouping/${category}`,
  );
  const resp = await api.post(wrapperConstants.router, requestPayload);
  return resp?.data ?? [];
};

// Save detailed downtime data (create or update)
export const saveDetailedDailyDowntime = async (data: any): Promise<boolean> => {
  try {
    const requestPayload = createWrapperPayload(
      'POST',
      `/pumpchecker/api/v1/Downtime/CreateOrUpdateWellDowntime`,
      data,
      false,
    );

    const response = await api.post(wrapperConstants.router, requestPayload);

    return response && response.status === 200;
  } catch (error) {
    console.error('Error saving downtime data to API:', error);
    return false;
  }
};
